import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCodeInsert: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCodeInsert"><Path d="M15.4954 2H16.9954V4H21.9954V20H16.9954V22H15.4954V2Z" fill="currentColor"/><Path fillRule="evenodd" clipRule="evenodd" d="M2 20V4H14V20H2ZM7.5 8.43934L6.43934 9.5L8.93934 12L6.43934 14.5L7.5 15.5607L11.0607 12L7.5 8.43934Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCodeInsert;
